import React from 'react'
import styled from '@emotion/styled'
import { H2, Text } from 'library/atoms/Typography'
import Link from 'next/link'
import Carousel, {
  CarouselSlide,
  CarouselSlot,
  CarouselNavigation
} from 'library/molecules/Carousel'
import CarouselSlideSkeleton, {
  SubtitleSlideSkeleton
} from 'library/pages/EolaMarketplace/EolaMarketplace.skeleton'
import { ComponentProps } from './index'
import SchedulableCard from 'library/molecules/SchedulableCard'

export const ActivityCarousel = ({
  title,
  lede,
  linkText,
  linkHref,
  schedulables
}: ComponentProps) => {
  return (
    <StyledSection>
      <StyledOneColumnWrapper>
        <StyledCarousel>
          <StyledCarouselHeader slot="container-start">
            <Info>
              <H2>{title}</H2>
              {lede ? lede : ''}
              {schedulables && linkHref && linkText ? (
                <Text fontStyle="p2" color="secondary">
                  <Link href={linkHref}>{linkText}</Link>
                </Text>
              ) : (
                <SubtitleSlideSkeleton />
              )}
            </Info>
            <CarouselNavigation />
          </StyledCarouselHeader>
          {schedulables
            ? schedulables.map(card => (
                <CarouselSlide key={card.title}>
                  <SchedulableCard
                    schedulable={card.schedulable}
                    externalHref={card.href}
                    outlet={card.outlet}
                    key={card.schedulable.id}
                  />
                </CarouselSlide>
              ))
            : /**
               * Load the skeleton if the data is not ready yet.
               */
              Array.from(Array(20).keys(), n => n + 1).map(card => (
                <CarouselSlide key={card}>
                  <CarouselSlideSkeleton />
                </CarouselSlide>
              ))}
        </StyledCarousel>
      </StyledOneColumnWrapper>
    </StyledSection>
  )
}

const Info = styled.div(() => ({
  maxWidth: '700px'
}))

const StyledSection = styled.section(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%'
}))

const StyledOneColumnWrapper = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space[7],
  padding: theme.mixins.pxSpread([0, theme.space[5]]),
  ...theme.mixins.centeredContainer('xxxl')
}))

const StyledCarousel = styled(Carousel)(({ theme }) => ({
  // Create space for the shadow that gets cut off because of the overflow hidden
  ...theme.mixins.createPseudoSpace({
    position: 'bottom',
    size: 8
  }),
  '.swiper-slide': {
    width: 320
  }
}))

const StyledCarouselHeader = styled(CarouselSlot)(({ theme }) => ({
  display: 'flex',
  flex: '1 0 0',
  justifyContent: 'space-between',
  marginBottom: theme.space[5],
  alignItems: 'flex-end'
}))
